const ListingFormNavObserverHook = {
  mounted() {
    this.visibleID;
    this.sections = document.querySelectorAll('[data-section]');

    this.observer = new IntersectionObserver(
      (entries) => {
        const intersectingEntry = entries.find((e) => e.isIntersecting);

        if (intersectingEntry) {
          this.visibleID = intersectingEntry.target.id;
          this.highlightSection();
        }
      },

      {
        // Trigger when any part of the section intersects
        threshold: 0,
        // Adjust the rootMargin to trigger when the section reaches 50% from the top
        rootMargin: `-${window.innerHeight / 2}px 0px -50% 0px`,
      }
    );

    this.sections.forEach((section) => {
      this.observer.observe(section);
    });
  },

  updated() {
    this.highlightSection();
  },

  beforeDestroy() {
    this.sections.forEach((section) => {
      this.observer.unobserve(section);
    });
  },

  highlightSection() {
    if (!this.visibleID) return;

    this.el.querySelectorAll('[data-section-link]').forEach((link) => {
      delete link.dataset.jsState;
    });

    const activeLink = this.el.querySelector(`[data-section-link][href='#${this.visibleID}']`);
    if (activeLink) {
      activeLink.dataset.jsState = 'active';
    }
  },
};

export default ListingFormNavObserverHook;
